export const ButtonPressH = () => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.583 4C21.5745 4 24 6.42546 24 9.41699V18.583C24 21.5745 21.5745 24 18.583 24H9.41699C6.42546 24 4 21.5745 4 18.583V9.41699C4 6.42546 6.42546 4 9.41699 4H18.583ZM11 10.3301V17H12.7305V14.2998H15.2305V17H16.9697V10.3301H15.2305V12.8203H12.7305V10.3301H11Z"
        fill="#E3E5FA"
      />
    </svg>
  );
};
